import { compose, eq, prop, or } from 'micro-fp';

import templateUrl from './index.html';
import './style.less';

class IntegrationIssuesCtrl {
  constructor(Authentication, GoogleCalendarUtils, IntegrationService, $rootScope) {
    'ngInject';

    Object.assign(this, { Authentication, GoogleCalendarUtils, IntegrationService, $rootScope });
  }

  $onInit() {
    this.updateErroredIntegrations();
  }

  async updateErroredIntegrations() {
    const integrations = await this.IntegrationService.getAvailableIntegrations();
    if (!integrations) {
      return;
    }
    this.erroredIntegrations = integrations
      .filter(prop('enabled'))
      .filter(compose(or(eq('ERROR_OAUTH'), eq('ERROR_BILLING')), prop('error')));
  }

  get shouldShowPrompt() {
    return this.erroredIntegrations && this.erroredIntegrations.length;
  }

  async confirm(integration) {
    await this.IntegrationService.disconnect(integration);
    await this.IntegrationService.connect(integration);
    await this.updateErroredIntegrations(integration);
    this.$rootScope.$broadcast('socket:integration:status');
  }

  async reject(integration) {
    await this.updateErroredIntegrations(integration);
    this.$rootScope.$broadcast('socket:integration:status');
  }
}

export default {
  templateUrl,
  controllerAs: 'ctrl',
  controller: IntegrationIssuesCtrl,
};
